import React from 'react';

/* eslint-disable */
const ArrowLeft = (props) => (
  <svg width="148" height="148" viewBox="0 0 148 148" {...props}>
    <path d="M32.0443694,74.3181784 C32.0443694,71.7627576 33.017035,69.2067055 34.9579608,67.2577039 L96.0961793,5.92634345 C99.9852685,2.02486786 106.29076,2.02486786 110.178276,5.92634345 C114.065791,9.82624065 114.065791,16.1505518 110.178276,20.0523431 L56.0806333,74.3181784 L110.1745,128.586223 C114.062015,132.486121 114.062015,138.811379 110.1745,142.71096 C106.286984,146.61433 99.9833804,146.61433 96.0942913,142.71096 L34.9557581,81.3805468 C33.015147,79.4305982 32.0443694,76.8745461 32.0443694,74.3181784 Z" />
  </svg>
);
/* eslint-enable */

export default ArrowLeft;
